var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3438 3.34375V2L7 5.34375L1.65625 2V3.34375L7 6.65625L12.3438 3.34375ZM12.3438 0.65625C12.6979 0.65625 13 0.791667 13.25 1.0625C13.5208 1.33333 13.6562 1.64583 13.6562 2V10C13.6562 10.3542 13.5208 10.6667 13.25 10.9375C13 11.2083 12.6979 11.3438 12.3438 11.3438H1.65625C1.30208 11.3438 0.989583 11.2083 0.71875 10.9375C0.46875 10.6667 0.34375 10.3542 0.34375 10V2C0.34375 1.64583 0.46875 1.33333 0.71875 1.0625C0.989583 0.791667 1.30208 0.65625 1.65625 0.65625H12.3438Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailWhite);
export default __webpack_public_path__ + "static/media/email_white.1c5f016ea86f0de1b0bc3fd25bb4c00b.svg";
export { ForwardRef as ReactComponent };